import TechStackBadge from './TechStackBadge.component';

export default TechStackBadge;
